import React, { useEffect, useState } from 'react';
export function MobileScrollIndicator() {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [activeSection, setActiveSection] = useState('home');
  const [isVisible, setIsVisible] = useState(false);
  const sections = [{
    id: 'home',
    label: 'Home'
  }, {
    id: 'about',
    label: 'Over mij'
  }, {
    id: 'services',
    label: 'Diensten'
  }, {
    id: 'qualifications',
    label: 'Kwalificaties'
  }, {
    id: 'experience',
    label: 'Ervaring'
  }, {
    id: 'availability',
    label: 'Tarieven'
  }, {
    id: 'contact-new',
    label: 'Contact'
  }];
  useEffect(() => {
    // Get all section elements
    const sectionElements = sections.map(section => ({
      id: section.id,
      ref: document.getElementById(section.id)
    })).filter(section => section.ref);
    // Calculate total scrollable height
    const documentHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;
    const scrollableHeight = documentHeight - windowHeight;
    // Handle scroll events
    const handleScroll = () => {
      // Calculate scroll progress percentage
      const scrollY = window.scrollY;
      const progress = Math.min(Math.max(scrollY / scrollableHeight, 0), 1);
      setScrollProgress(progress * 100);
      // Determine active section
      const scrollPosition = scrollY + windowHeight / 3;
      for (let i = sectionElements.length - 1; i >= 0; i--) {
        const section = sectionElements[i];
        if (section.ref && section.ref.offsetTop <= scrollPosition) {
          setActiveSection(section.id);
          break;
        }
      }
      // Show indicator when scrolling starts, hide after scrolling stops
      setIsVisible(true);
      clearTimeout(window.scrollTimeout);
      window.scrollTimeout = setTimeout(() => {
        setIsVisible(false);
      }, 2000);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(window.scrollTimeout);
    };
  }, []);
  // Find the index of the active section
  const activeSectionIndex = sections.findIndex(section => section.id === activeSection);
  // Scroll to section when clicking on a section indicator
  const scrollToSection = id => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 70,
        behavior: 'smooth'
      });
    }
  };
  return <div className={`lg:hidden fixed top-0 left-0 right-0 z-50 transition-opacity duration-300 ${isVisible ? 'opacity-100' : 'opacity-0'}`} data-id="element-256">
      {/* Progress bar */}
      <div className="h-1 bg-zinc-900 w-full" data-id="element-257">
        <div className="h-full bg-slate-700 transition-all duration-200 ease-out" style={{
        width: `${scrollProgress}%`
      }} data-id="element-258"></div>
      </div>
      {/* Section indicator */}
      <div className="bg-zinc-900 bg-opacity-90 backdrop-blur-sm border-b border-zinc-800 px-4 py-2 flex items-center justify-between" data-id="element-259">
        <div data-id="element-260">
          <span className="text-sm font-normal text-slate-300" data-id="element-261">
            {sections[activeSectionIndex]?.label}
          </span>
        </div>
        {/* Section dots */}
        <div className="flex items-center gap-2" data-id="element-262">
          {sections.map((section, index) => <button key={section.id} onClick={() => scrollToSection(section.id)} className={`w-2 h-2 rounded-full transition-all ${index === activeSectionIndex ? 'bg-slate-500' : index < activeSectionIndex ? 'bg-slate-800' : 'bg-zinc-700'}`} aria-label={`Scroll to ${section.label}`} data-id="element-263" />)}
        </div>
      </div>
    </div>;
}